import React from 'react';

import { TitleWithDescription } from '@infoods/lifebase-ui';

import classes from './CompleteStep.module.scss';
import { STEP_FORM_ID } from '../../GuidedChallengeCreation.settings';
import SuccessImage from '../../../../../../../../../assets/images/vectors/success-rounded.svg';

type Props = {
  onSubmit: (e: React.FormEvent) => void;
};

const CompleteStep = ({ onSubmit }: Props) => {
  return (
    <form id={STEP_FORM_ID} onSubmit={onSubmit} noValidate className={classes.box}>
      <img src={SuccessImage} alt="success" className={classes.image} />
      <TitleWithDescription
        title="Thank You for Providing Initial Details About Your Challenge!"
        description={
          <span>
            Click the &quot;Preview draft&quot; button to finish the setup process.
            <br />
            Your challenge is in the &quot;draft&quot; mode for you to continue input.
          </span>
        }
        titleFont="title-18-bold"
      />
    </form>
  );
};

export { CompleteStep };
